import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { label: "Product", to: "/product" },
  { label: "Solutions", to: "/solutions" },
  { label: "AI", to: "/ai" },
  { label: "Pricing", to: "/pricing" },
  { label: "About", to: "/about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#000000]/80 backdrop-blur-xl border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16 md:h-20">
        <Logo size="md" />

        <nav className="hidden md:flex items-center gap-1">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-3.5 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive
                    ? "text-white bg-white/5"
                    : "text-[#94A3B8] hover:text-white"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link
            to="/demo"
            data-testid="nav-request-demo-btn"
            className="inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#ea580c] active:scale-95 text-white font-semibold text-sm px-4 py-2.5 rounded-lg transition-all shadow-[0_4px_24px_rgba(249,115,22,0.35)]"
          >
            Request Demo
          </Link>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          className="md:hidden h-10 w-10 grid place-items-center rounded-lg bg-white/5 border border-white/10 text-white"
          onClick={() => setOpen((s) => !s)}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/5 bg-[#000000]/95 backdrop-blur-xl">
          <div className="container-x py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                data-testid={`nav-mobile-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-base font-medium ${
                    isActive ? "text-white bg-white/5" : "text-[#94A3B8]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/demo"
              data-testid="nav-mobile-demo-btn"
              className="mt-2 text-center bg-[#F97316] text-white font-semibold py-3 rounded-lg"
            >
              Request Demo
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
